import React, { useContext, useEffect, useState } from "react";
import { Col, Menu, Row, Image, Badge } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dashboardIcon from "../../../assets/images/menuImages/dashboard.svg";
import facilityIcon from "../../../assets/images/menuImages/facilities.svg";
import activeFacility from "../../../assets/images/menuImages/fecilitiesActive.svg";
import services from "../../../assets/images/menuImages/services.svg";
import activeServices from "../../../assets/images/menuImages/servicesActive.svg";
import investigation from "../../../assets/images/menuImages/investigation.svg";
import medication from "../../../assets/images/menuImages/medication.svg";
import diet from "../../../assets/images/menuImages/diet.svg";
import patients from "../../../assets/images/menuImages/users.svg";
import users from "../../../assets/images/menuImages/allUsers.svg";
import activeUserIcon from "../../../assets/images/menuImages/ActiveAllUsers.svg";
import activeDiet from "../../../assets/images/menuImages/activeDiet.svg";
import patientsActive from "../../../assets/images/menuImages/activeUserIcon.svg";
import investigationActive from "../../../assets/images/menuImages/investigationActive.svg";
import medicalActive from "../../../assets/images/menuImages/medicalActive.svg";
import homeActive from "../../../assets/images/menuImages/homeActive.svg";
import partnerActive from "../../../assets/images/patientIcons/Partner onboardingActive.svg";
import partnerInActive from "../../../assets/images/patientIcons/Partner onboarding.svg";
import therapiesInActive from "../../../assets/images/menuImages/Therapies.svg";
import therapiesActive from "../../../assets/images/menuImages/TherapiesActive.svg";
import serviceRequest from "../../../assets/images/menuImages/service-request.svg";
import serviceRequestActive from "../../../assets/images/menuImages/service-requesActive.svg";
import usageactive from "../../../assets/images/menuImages/usageactive.svg";
import usageInactive from "../../../assets/images/menuImages/usageInactive.svg";
import { SettingOutlined } from "@ant-design/icons";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import {
  fetchServiceRequestsCounts,
  SERVICE_REQUESTS_COUNT_UPDATED_EVENT,
} from "../../../services/serviceRequests.services";
import "./SideMenu.css";

const SideMenu = ({ collapsed }) => {
  const { userDetails } = useContext(UserContext);
  const [pendingServiceRequests, setPendingServiceRequests] = useState(0);
  const router = useParams();
  // console.log(router);
  const navigate = useNavigate();
  const location = useLocation();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const defaultRole = userDetails?.currRole || getCookie(Role);
  // Extract the last part of the route as the selected key
  const pathParts = router?.["*"]?.split("/") || [];
  const routeKey = pathParts[pathParts.length - 1];
  const selectedKey =
    routeKey === "final-discharge-dashboard" ? "ip-dashboard" : routeKey;

  const dashboardChildKeys = [
    "overview",
    "ip-dashboard",
    "op-dashboard",
    "operations",
  ];

  const getOpenKeysForState = (isCollapsed, key) => {
    if (isCollapsed) return [];
    if (dashboardChildKeys.includes(key)) return ["home"];
    return [];
  };

  const [menuOpenKeys, setMenuOpenKeys] = useState(() =>
    getOpenKeysForState(collapsed, selectedKey)
  );

  useEffect(() => {
    setMenuOpenKeys(getOpenKeysForState(collapsed, selectedKey));
  }, [selectedKey, collapsed, location.pathname]);

  const isDashboardChildSelected = dashboardChildKeys.includes(selectedKey);
  const isSettingsChildSelected = ["ip-whitelisting"].includes(selectedKey);
  const facilityName =
    defaultRole === "Facility_Admin" ? "Facility" : "Facilities";

  function getItem(label, key, icon, children, type, className) {
    return {
      key,
      icon,
      children,
      label,
      type,
      className,
    };
  }

  const menuImages = (icon, badgeCount = 0) => {
    const imageNode = (
      <span
        role="img"
        aria-label="user"
        className="anticon anticon-user ant-menu-item-icon"
      >
        <Image
          src={icon}
          preview={false}
          style={{ height: "20px", width: "auto", marginBottom: "8px" }}
        />
      </span>
    );

    return badgeCount > 0 ? (
      <Badge
        className="side-menu-badge"
        count={badgeCount}
        size="small"
        overflowCount={99}
        offset={[6, -2]}
      >
        {imageNode}
      </Badge>
    ) : (
      imageNode
    );
  };

  useEffect(() => {
    const isAdmin =
      defaultRole === "Organization_Admin" || defaultRole === "Facility_Admin";
    if (!isAdmin) return;

    const loadPendingCount = () => {
      fetchServiceRequestsCounts()
        .then((res) => {
          const pending = res?.data?.data?.total_pending ?? 0;
          setPendingServiceRequests(pending);
        })
        .catch((err) => {
          console.error("Failed to fetch service request counts", err);
        });
    };

    const onCountUpdated = (event) => {
      const pending = event?.detail?.pending;
      if (typeof pending === "number") {
        setPendingServiceRequests(pending);
        return;
      }
      loadPendingCount();
    };

    loadPendingCount();
    window.addEventListener(
      SERVICE_REQUESTS_COUNT_UPDATED_EVENT,
      onCountUpdated
    );

    return () => {
      window.removeEventListener(
        SERVICE_REQUESTS_COUNT_UPDATED_EVENT,
        onCountUpdated
      );
    };
  }, [defaultRole]);
  const items = [
    getItem(
      "Dashboard",
      "home",
      router?.["*"]?.startsWith("home")
        ? menuImages(homeActive)
        : menuImages(dashboardIcon),
      [
        { key: "overview", label: "Overview" },
        { key: "ip-dashboard", label: "IP Dashboard" },
        { key: "op-dashboard", label: "OP Dashboard" },
        { key: "operations", label: "Operations" },
      ],
      undefined,
      isDashboardChildSelected ? "parent-selected" : ""
    ),
    getItem(
      "Usage Overview",
      "usage-overview",
      router?.["*"] === "usage-overview"
        ? menuImages(usageInactive)
        : menuImages(usageactive)
    ),
    getItem(
      facilityName,
      "facilities",
      router?.["*"] === "facilities"
        ? menuImages(activeFacility)
        : menuImages(facilityIcon)
    ),
    getItem(
      "Services & Packages",
      "services",
      router?.["*"] === "services"
        ? menuImages(activeServices)
        : menuImages(services)
    ),
    getItem(
      "Investigations",
      "investigation",
      router?.["*"] === "investigation"
        ? menuImages(investigationActive)
        : menuImages(investigation)
    ),
    getItem(
      "Medicines",
      "medication",
      router?.["*"] === "medication"
        ? menuImages(medicalActive)
        : menuImages(medication)
    ),
    getItem(
      "Diet Menu",
      "diet-menu",
      router?.["*"] === "diet-menu" ? menuImages(activeDiet) : menuImages(diet)
    ),
    ...(defaultRole === "Organization_Admin" || defaultRole === "Facility_Admin"
      ? [
          getItem(
            "Therapies",
            "therapies",
            router?.["*"] === "therapies"
              ? menuImages(therapiesActive)
              : menuImages(therapiesInActive)
          ),
        ]
      : []),
    getItem(
      "Service Requests",
      "service-requests",
      router?.["*"] === "service-requests"
        ? menuImages(serviceRequestActive, pendingServiceRequests)
        : menuImages(serviceRequest, pendingServiceRequests)
    ),
    getItem(
      "Patients",
      "patients",
      router?.["*"] === "patients"
        ? menuImages(patientsActive)
        : menuImages(patients)
    ),
    ...(defaultRole === "Organization_Admin" || defaultRole === "Facility_Admin"
      ? [
          getItem(
            "Partner Onboarding",
            "partner_onboarding",
            router?.["*"] === "partner_onboarding"
              ? menuImages(partnerActive)
              : menuImages(partnerInActive)
          ),
        ]
      : []),
    getItem(
      "Users",
      "users",
      router?.["*"] === "users" ? menuImages(activeUserIcon) : menuImages(users)
    ),
    ...(defaultRole === "Facility_Admin"
      ? [
          getItem(
            "Settings",
            "settings",
            <SettingOutlined style={{ fontSize: 18 }} />,
            [{ key: "ip-whitelisting", label: "IP Whitelisting" }],
            undefined,
            isSettingsChildSelected ? "parent-selected" : ""
          ),
        ]
      : []),
  ];

  const onClick = (e) => {
    const isFacilityAdmin = defaultRole === "Facility_Admin";
    const facilityParam = isFacilityAdmin
      ? `facility=${
          params?.facility
            ? params?.facility
            : userDetails?.activeOrg?.facilities?.[0]?.facility_id
        }`
      : "";

    let path;

    switch (e.key) {
      case "home":
        path = `/dashboard/home/${e.key}?type=admissions-overview`;
        break;
      case "overview":
        path = `/dashboard/home/${e.key}?type=admissions-overview`;
        break;
      case "ip-dashboard":
        path = `/dashboard/home/${e.key}`;
        break;
      case "op-dashboard":
        path = `/dashboard/home/${e.key}`;
        break;
      case "operations":
        path = `/dashboard/home/${e.key}`;
        break;
      case "final-discharge-dashboard":
        path = `/dashboard/home/ip-dashboard?report=final_discharge`;
        break;
      case "users":
        path = `/dashboard/${e.key}?role=all`;
        break;
      case "service-requests":
        path = `/dashboard/${e.key}?status=PENDING`;
        break;
      case "medication":
        path = `/dashboard/${e.key}?medicine=medicine_list`;
        break;
      case "services":
        path = `/dashboard/${e.key}?type=services`;
        break;
      case "therapies":
        path = `/dashboard/therapies`;
        break;
      case "settings":
        path = `/dashboard/settings/ip-whitelisting`;
        break;
      case "ip-whitelisting":
        path = `/dashboard/settings/ip-whitelisting`;
        break;
      default:
        path = `/dashboard/${e.key}`;
    }

    if (isFacilityAdmin) {
      path += path.includes("?") ? `&${facilityParam}` : `?${facilityParam}`;
    }

    if (collapsed) {
      setMenuOpenKeys([]);
    }

    navigate(path);
  };

  const handleOpenChange = (keys) => {
    if (collapsed) {
      setMenuOpenKeys(keys);
      return;
    }
    setMenuOpenKeys(keys);
  };

  return (
    <Row>
      <Col span={24}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Menu
              style={{ border: 0 }}
              onClick={onClick}
              selectedKeys={[selectedKey]}
              openKeys={menuOpenKeys}
              onOpenChange={handleOpenChange}
              mode="inline"
              inlineCollapsed={collapsed}
              triggerSubMenuAction="click"
              items={items}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SideMenu;
